<template>
  <div>
    <div v-for="(label, field) in filterFields" :key="field">
      <slot :name="field">
        <v-text-field
          :label="'Ingrese ' + label"
          v-model="carrera[field]"
          :error-messages="errors[field]"
        ></v-text-field>
      </slot>
    </div>
    <slot name="field"></slot>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "CarreraForm",
  props: {
    only: {
      type: Array,
      default: () => {
        return [];
      },
    },
    exclude: {
      type: Array,
      default: () => {
        return ["id"];
      },
    },
  },
  computed: {
    ...mapState("CarreraModule", ["carrera", "emptyModel", "fields"]),
    ...mapGetters("CarreraModule", ["errors"]),
    // ...mapGetters(["carrera","carreraFields","carreraErrors"]),
    filterFields() {
      let fields = {};
      if (this.only.length > 0) {
        for (var j in this.only) {
          let attr = this.only[j] in this.fields;
          if (attr) {
            fields[this.only[j]] = this.fields[this.only[j]];
          }
        }
        return fields;
      }
      if (this.exclude.length > 0) {
        for (var i in this.fields) {
          let attr = this.exclude.find((el) => el == i);
          if (!attr) {
            fields[i] = this.fields[i];
          }
        }
        return fields;
      }
      return this.fields;
    },
  },
};
</script>

<style scoped></style>
